import { api } from "./api";
import type {
  JobListItem,
  JobDetail,
  JobCreateRequest,
  JobManualCreateRequest,
  JobPatchRequest,
  AnalysisResponse,
} from "../types";

export interface DuplicateCheckResult {
  exists: boolean;
  job?: {
    id: string;
    title: string | null;
    company: string | null;
  };
}

export const jobsService = {
  list: () => api.get<JobListItem[]>("/api/jobs"),

  createFromUrl: (data: JobCreateRequest) =>
    api.post<JobDetail>("/api/jobs", data),

  createManual: (data: JobManualCreateRequest) =>
    api.post<JobDetail>("/api/jobs/manual", data),

  get: (id: string) => api.get<JobDetail>(`/api/jobs/${id}`),

  update: (id: string, data: JobPatchRequest) =>
    api.patch<JobDetail>(`/api/jobs/${id}`, data),

  delete: (id: string) => api.delete<void>(`/api/jobs/${id}`),

  analyze: (id: string) => api.post<AnalysisResponse>(`/api/jobs/${id}/analyze`),

  checkDuplicate: async (url: string): Promise<DuplicateCheckResult | null> => {
    try {
      const timeout = new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error("timeout")), 3000)
      );
      return await Promise.race([
        api.get<DuplicateCheckResult>(
          `/api/jobs/check-duplicate?url=${encodeURIComponent(url)}`
        ),
        timeout,
      ]);
    } catch {
      return null;
    }
  },
};
